// extracted by mini-css-extract-plugin
export default {"outer":"CustomSelect_outer__jr2J9","select":"CustomSelect_select__3dYEz","item":"CustomSelect_item__eRIMN","input":"CustomSelect_input__wHDlw","label":"CustomSelect_label__8q8eq"};